import {DummyNodeDef} from "../parser/definition/types/DummyNodeDef";

export function compileDummyNodeDef<I, O>(
  factoryId: string,
  dummyNodeDef: DummyNodeDef<I, O>
): string {
  const nodeDefStr = JSON.stringify(dummyNodeDef, null, 2);
  return `const ${factoryId} = (params) => createDummyNode(${nodeDefStr}, params);`;
}
